import React, { useEffect, useState } from "react";
import { Button, Modal, Select } from "antd";
import FilterIcon from "../../assets/images/Svg/FilterIcon.svg";
import AppointmentTable from "./AppointmentTable";
import AppointmentFilter from "./AppointmentFilter";
import { CloseOutlined } from "@ant-design/icons";
import Layout from "../../Layout";
import PatientService from "../../Services/PatientService";
import { MdFamilyRestroom } from "react-icons/md";

const MyAppointments = () => {
  const patJson = sessionStorage.getItem("patientData");
  const patObj = patJson ? JSON.parse(patJson) : null;
  const [isModalOpen1, setIsModalOpen1] = useState(false);
  const [filterValues, setFilterValues] = useState(null);
  const [famList, setFamList] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(patObj);

  useEffect(() => {
    getFamilyList();
  }, []);

  const getFamilyList = async () => {
    const payload = {
      parentPatientId: patObj?.patientId,
    };

    try {
      const response = await PatientService.getPatient(payload);
      setFamList(response.data);
    } catch (e) {
      console.error(e);
    }
  };

  const handleFilter = () => {
    if (filterValues) {
      setFilterValues(null);
    } else {
      setIsModalOpen1(true);
    }
  };

  const handleCloseModal = (values) => {
    setFilterValues(values);
    setIsModalOpen1(false);
  };

  const handlePatientChange = (value) => {
    if (value === patObj.patientId) {
      setSelectedPatient(patObj);
    } else {
      const selectedPatObj = famList.find((pat) => pat.patientId === value);
      setSelectedPatient(selectedPatObj);
    }
  };

  return (
    <Layout>
      <div className="px-5 pt-5">
        <div className="flex sm:flex-col justify-between">
          <h2 className="font-bold text-lg">Appointments</h2>
          <div className="flex items-center gap-2 mb-3">
            {!patObj?.parentPatientId && (
              <div className="flex items-center gap-2">
                <MdFamilyRestroom className="text-iconBlue" />
                <Select
                  className="w-36 h-9"
                  value={selectedPatient.patientId}
                  onChange={handlePatientChange}
                >
                  <Select.Option value={patObj?.patientId}>
                    {patObj.firstName}
                  </Select.Option>
                  {famList.length !== 0 &&
                    famList.map((fam) => (
                      <Select.Option value={fam.patientId}>
                        {fam.firstName}
                      </Select.Option>
                    ))}
                </Select>
              </div>
            )}

            <Button
              onClick={handleFilter}
              className="w-20 h-9 px-2 flex items-center gap-2 custom_filter"
            >
              {filterValues ? (
                <div className="flex items-center">
                  <span className="text-white mx-1">Clear</span>
                  <CloseOutlined
                    style={{ color: "white", marginLeft: "4px" }}
                  />
                </div>
              ) : (
                <div className="flex items-center">
                  <span>
                    <img src={FilterIcon} alt="Icon" />
                  </span>
                  <span className="text-white ml-2">Filter</span>
                </div>
              )}
            </Button>
          </div>
        </div>
        <div>
          <AppointmentTable
            selectedPatient={selectedPatient ? selectedPatient : patObj}
            filterValues={filterValues}
          />
        </div>
      </div>

      {isModalOpen1 && (
        <Modal
          title={
            <span className="text-base font-bold font-sans">
              Appointment Filter
            </span>
          }
          visible={isModalOpen1}
          onOk={() => handleCloseModal()}
          centered={true}
          footer={null}
          onCancel={() => handleCloseModal()}
          okText="Submit"
          cancelText="Cancel"
          width={600}
          maskClosable={false}
        >
          <AppointmentFilter onClose={(values) => handleCloseModal(values)} />
        </Modal>
      )}
    </Layout>
  );
};
export default MyAppointments;
